// extracted by mini-css-extract-plugin
export default {"base":"Faq_base__yzlTf","title":"Faq_title__Jj1T5","faqItems":"Faq_faqItems__OdhIi"};